import { Divider as MuiDivider, DividerProps as MuiDividerProps } from '@mui/material';

export const Divider = MuiDivider;
export type DividerProps = MuiDividerProps;
